export const FILTER_KEYWORD = {
  SET_FILTER_KEYWORD: 'SET_FILTER_KEYWORD',
  CLEAR_FILTER_KEYWORD: 'CLEAR_FILTER_KEYWORD',
};
